export const tableColumns = [
    {
        type: 'selection',
        fixed: true
    },
    {
        label: 'SKU',
        prop: 'id',
        minWidth: 120
    },
    {
        label: window.$t('stores::products-info::图片'),
        prop: 'imageUrl',
        minWidth: 120
    },
    {
        label: window.$t('stores::products-info::purchase_price'),
        prop: 'purchasePrice',
        minWidth: 120
    },
    {
        label: window.$t('stores::products-info::compare_at_price'),
        prop: 'compareAtPrice',
        minWidth: 120
    },
    {
        label: window.$t('stores::products-info::sale_price'),
        prop: 'salePrice',
        minWidth: 120
    },
    {
        label: window.$t('stores::products-info::safe_stock'),
        prop: 'safeInventory',
        minWidth: 120
    },
    {
        label: window.$t('stores::products-info::goods_stock'),
        prop: 'skuInventory',
        minWidth: 120
    },
    {
        label: window.$t('stores::products-info::weight'),
        prop: 'weight',
        minWidth: 120
    },
    {
        label: window.$t('stores::products-info::operate'),
        prop: 'opt',
        minWidth: 210,
        fixed: 'right'
    }
]